<div class="rhynothon-container">
  <!-- 🎯 Wrapper para timer + notificação terem mesma largura -->
  <div class="timer-wrapper">
    <!-- Timer existente -->
    <div class="timer-display" [ngStyle]="containerStyles">
      <div class="time-segment" *ngIf="displayDays > 0">
        <span class="time-value">{{ formatTime(displayDays) }}</span>
      </div>
      <div class="time-separator" *ngIf="displayDays > 0">:</div>
      
      <div class="time-segment">
        <span class="time-value">{{ formatTime(displayHours) }}</span>
      </div>
      <div class="time-separator">:</div>
      
      <div class="time-segment">
        <span class="time-value">{{ formatTime(displayMinutes) }}</span>
      </div>
      <div class="time-separator">:</div>
      
      <div class="time-segment">
        <span class="time-value">{{ formatTime(displaySeconds) }}</span>
      </div>
    </div>

    <!-- 🎯 Notificação minimalista (slide de dentro pra baixo) -->
    <div class="event-notification" *ngIf="showNotification">
      <div class="event-content" [ngStyle]="containerStyles" [style.border-left-color]="notificationData?.platformColor || '#fff'">
        <div class="event-icons">
          <img class="platform-icon" *ngIf="notificationData?.platformIconPath" [src]="notificationData?.platformIconPath" alt="Platform">
          
          <!-- Type icon: suporta Material Icon ou imagem PNG -->
          <span *ngIf="notificationData?.typeIcon" 
                class="type-icon material-icons">{{ notificationData?.typeIcon }}</span>
          <img *ngIf="notificationData?.typeIconPath" 
               class="type-icon-image" 
               [src]="notificationData?.typeIconPath"
               alt="Type Icon">
        </div>
        <span class="event-text">
          <strong>{{ notificationData?.contributorName }}</strong>
          <span class="event-value" [style.color]="notificationData?.platformColor || '#fff'">{{ notificationData?.displayValue }}</span>
        </span>
      </div>
    </div>
  </div>

  <!-- 🔧 Botões de teste (somente em dev) -->
  <div class="test-controls" *ngIf="isLocal" style="position: fixed; bottom: 10px; right: 10px; display: flex; flex-direction: column; gap: 5px; z-index: 9999;">
    <button style="padding: 8px 12px; background: #9146FF; color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" (click)="onTestNotification()">
      ⭐ Test Twitch Sub
    </button>
    <button style="padding: 8px 12px; background: #53FC18; color: black; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" (click)="onTestKickSub()">
      💚 Test Kick Sub
    </button>
    <button style="padding: 8px 12px; background: #FF0000; color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" (click)="onTestYoutubeMember()">
      ▶️ Test YouTube Member
    </button>
    <button style="padding: 8px 12px; background: #FF6B35; color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" (click)="onTestDonation()">
      💰 Test Donation
    </button>
    <button style="padding: 8px 12px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" (click)="onTestSale()">
      🛒 Test Sale
    </button>
  </div>
</div>